/*
 * @Date: 2019-08-26 14:33:05
 * @LastEditTime: 2020-05-21 18:00:18
 */ 
import Vue from 'vue'
//store.dispatch("userInfo/getEntityStatus",10);
const state = {}
  // getters
const getters = {
	getState:state => {
		 return state;
	},
	getRealStatus:(state)=>{
		if(state.entityStatus){
			if(state.entityStatus.status){
				return state.entityStatus.status;
			}else{
				return 0;
			}			
		}else{			
			return 0;
		}
	},
	getEntityStatus: state => {
		if(state.entityStatus){
			if(state.entityStatus.status){
				return state.entityStatus.status;
			}else{
				return 10;
			}			
		}else{			
			return 10;
		}
  },
  getSupplierStatus:state=>{
  	if(state.entityStatus.supplierStatus){  		
				return state.entityStatus.supplierStatus;
		}else{
			  return {}
		}
  },
  getInfoStatus:(state)=>{
  	if(state.changeInfo){
  		return state.changeInfo.status;
  	}else{
  		return 0;
  	}
  }
}  // actions
const actions = {   //异步
    getEntityStatus({commit}, name) { // commit 提交；name即为点击后传递过来的参数
    	axios({
	        url: P.ajaxUrl+"/supplier/apply/index",		        
	        method: 'post',
			type: 'json',
			data:{startDate:'',endDate:''},
	    }).then((data) => {
	    	//console.log(data)
	      	let D = data.data;	
	      	if(D.resultCode == 0){	      		
	      		commit ('getEntityStatus', D.data);
	      	}else{		      		
	      		console.log(data.resultMessage)
	      	}
	    });    	
	  },
    getDataChange({commit},arg){  
    	if(typeof arg.actionPost == "function"){
	    	arg.actionPost({url:"/supplier/dataChangeInfo",params:arg.params},(data)=>{
					  commit('getChangeInfo',data.data);//10 审核中 20//通过  30 //不通过				 
				});
    	}else{
    		commit('getChangeInfo',{status:arg});
    	}
    }
}// mutations
const mutations = {
    getEntityStatus (state, arg) {    	
    	Vue.set(state, "entityStatus", arg); //设置属性需要使用vue.set 才能触发 getters    	
    },
    getChangeInfo(state,data){
    	Vue.set(state, "changeInfo", data); 
    }
}  
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/userinfo.js